import React, {useEffect, useState} from "react";
import {
  PBagIcon,
  PLinkIcon,
  PLocIcon,
  PMessIcon,
  PPhoneIcon,
  PUserE2Icon,
  PUserEIcon,
  PUserIcon,
} from "../../../../assets/icons/profileIcons";
import "./form.scss";
import {UserAuthService} from "../../../services/user-auth-api.service";
import MyProfileSkeleton from "../../skeletons/my-profile/MyProfileSkeleton";
import {useUser} from "../../../providers/UserContext";
import {useNavigate, useParams} from "react-router-dom";
import {Col, Row} from "antd";
import Heading from "../../../components/dashboard/heading-component/Heading";

export default function UserProfile() {
  let { id } = useParams();
  const [editProfile, setEditProfile] = useState(false);
  const [editProfessional, setEditProfessional] = useState(false);
  const [profileDatas, setProfileDatas] = useState(false);
  const [badgesData, setBadgesData] = useState([]);
  const [loader, setLoader] = useState(true);
  const { setProfileUpdate, profileUpdate } = useUser();

  let navigate = useNavigate();

  async function GetProfileData() {
    let params = {
      userIds: id,
    };
    setLoader(true);
    const response = await UserAuthService.getProfileById(params);
    // const response = await GetProfileById(params);
    if (response?.data?.data?.status) {
      setProfileDatas(response.data?.data?.data?.user[0]);
      setLoader(false);
      setBadgesData(response.data?.data?.data?.user[0]?.badges);
    }
  }

  useEffect(() => {
    GetProfileData();
  }, []);

  const items = [
    {
      key: "1",
      label: (
        <span
          onClick={() => {
            setEditProfile(true);
          }}
        >
          <PUserE2Icon /> Edit Profile
        </span>
      ),
    },
    {
      key: "2",
      label: (
        <span
          onClick={() => {
            setEditProfessional(true);
          }}
        >
          <PUserEIcon /> Edit Professional Profile
        </span>
      ),
    },
  ];

  if (loader) {
    return <MyProfileSkeleton />;
  }
  const lastRank = profileDatas?.ranks?.[profileDatas?.ranks?.length - 1];

  return (
    <div className={"my-profile"}>
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={24} xl={24}>
          <Heading back={true} heading={'Other Profiles'}/>
        </Col>
        <Col xs={24} md={24} lg={10} xl={10}>
          <div className={"my-profile-box"}>
            <div className={"profile-box-sec"}>
              <div className={"profile-box"}>
                {/*<BorderWrapper radius={'50%'}>*/}
                <div className={"profile-avatar"}>
                  <img src={profileDatas?.profileImage} className={"img-fluid"} />
                </div>
                {/*</BorderWrapper>*/}
                <div className={"profile-content"}>
                  <h4>{profileDatas?.fullName}</h4>
                  {lastRank && <img src={lastRank?.after.imageUrl} />}
                </div>
              </div>
              <div className={"my-profile-box-list"}>
                <ul>
                  <li>
                    <div className={"my-profile-box-list-card"}>
                      <div className={"icon"}>
                        <PMessIcon />
                      </div>
                      <div className={"content"}>
                        <p>Email Address</p>
                        <h5>{profileDatas?.email}</h5>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className={"my-profile-box-list-card"}>
                      <div className={"icon"}>
                        <PPhoneIcon />
                      </div>
                      <div className={"content"}>
                        <p> Phone no.</p>
                        <h5>{profileDatas?.phone}</h5>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className={"my-profile-box-list-card"}>
                      <div className={"icon"}>
                        <PLocIcon />
                      </div>
                      <div className={"content"}>
                        <p> Address</p>
                        <h5>{profileDatas?.address}</h5>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              {/*<div className={"my-profile-box-2"}>*/}
              {/*  <h4>Discount Code</h4>*/}
              {/*  <div className={"content"}>*/}
              {/*    {!lastRank && <p>No Ranks Yet</p>}*/}
              {/*    {lastRank && (*/}
              {/*      <img*/}
              {/*        src={lastRank?.after?.imageUrl}*/}
              {/*        className={"rank-img"}*/}
              {/*      />*/}
              {/*    )}*/}
              {/*    {lastRank && <p>Code: {lastRank?.discountCode}</p>}*/}
              {/*  </div>*/}
              {/*</div>*/}
              <div className={"my-profile-box-2"}>
                <h4>Badges</h4>
                <div className={"content"}>
                  <div className={"badges-sec"}>
                    {badgesData?.map((badge, index) => (
                        <img
                            className={"badge-img"}
                            src={badge?.after?.imageUrl}
                        />
                    ))}
                    {badgesData.length <= 0 && <p>No Badges Yet</p>}
                  </div>

                  {/*<span>See all badges</span>*/}
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col className={"mt-2 mt-lg-0"} xs={24} md={24} lg={10} xl={10}>
          <div className={"my-profile-box"}>
            {/*<ProfileChart />*/}
            <div className={"profile-box-sec"}>
              <h3>Professional Info</h3>
              <div className={"my-profile-box-list"}>
                <ul>
                  {/*<li>*/}
                  {/*  <div className={"my-profile-box-list-card"}>*/}
                  {/*    <div className={"icon"}>*/}
                  {/*      <PCapIcon />*/}
                  {/*    </div>*/}
                  {/*    <div className={"content"}>*/}
                  {/*      <p>RUK Graduated Date</p>*/}
                  {/*      <h5>*/}
                  {/*        {dayjs(profileDatas?.createdAt).format("DD-MM-YYYY")}*/}
                  {/*      </h5>*/}
                  {/*    </div>*/}
                  {/*  </div>*/}
                  {/*</li>*/}
                  <li>
                    <div className={"my-profile-box-list-card"}>
                      <div className={"icon"}>
                        <PUserIcon />
                      </div>
                      <div className={"content"}>
                        <p>Pod</p>
                        <h5>{profileDatas?.podNumber ? profileDatas?.podNumber : '-'}</h5>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className={"my-profile-box-list-card"}>
                      <div className={"icon"}>
                        <PLocIcon />
                      </div>
                      <div className={"content"}>
                        <p>Business Industry</p>
                        <h5>
                          {profileDatas?.additionalFields?.businessIndustry ? profileDatas?.additionalFields?.businessIndustry : '-'}
                        </h5>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className={"my-profile-box-list-card"}>
                      <div className={"icon"}>
                        <PBagIcon />
                      </div>
                      <div className={"content"}>
                        <p>Business Name</p>
                        <h5>{profileDatas?.additionalFields?.businessName ? profileDatas?.additionalFields?.businessName : '-' }</h5>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className={"my-profile-box-list-card"}>
                      <div className={"icon"}>
                        <PLinkIcon />
                      </div>
                      <div className={"content"}>
                        <p>Business Website Link</p>
                        <h5>  {profileDatas?.additionalFields?.websiteLink ? <a target={'_blank'} href={profileDatas?.additionalFields?.websiteLink}>{profileDatas?.additionalFields?.websiteLink}</a>  : '-' }</h5>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
